import type { Base64String } from '../types';

export const base64RemovePadding = (str: Base64String) => {
  return str.replace(/={1,2}$/, '');
};
